import { HttpInterceptorFn, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EncryptionDecryptionService } from '../services/EncryptionDecryption.service';
import { SessionStorageService } from '../services/sessionl-storage.service';
import { User } from '../class/user.class';
import { ENV_TOKEN } from '../../app-module.token';


export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {

  const crypto = inject(EncryptionDecryptionService);
  const environment = inject(ENV_TOKEN);

  if (req.url.includes('wsCatalogoEEAPI')) {
    return next(req);
  }

   if (req.url.includes(environment.host)) { // url captcha
    return next(req);
  }

  if (req.url.includes('unc.api.filepath')) { // nueva firma documento precargado
    return next(req);
  }

  const authToken = getToken();
  const modifiedReq = req.clone({
    headers: req.headers.set('Authorization', `Bearer ${authToken}`)
  });

  if (req.body) {
    const encryptedBody = crypto.Encryption(JSON.stringify(req.body));
    //const desencryptedBody = crypto.Decryption(encryptedBody);
    const encrypteReq = req.clone({
      body: { data: encryptedBody }, // Envolvemos el cuerpo cifrado en un objeto con una propiedad "data"
      headers: req.headers.set('Authorization', `Bearer ${authToken}`),
      setHeaders: {
        'X-Encrypted': 'true',
        'Content-Type': 'application/json',
      }
    });
    return next(encrypteReq);
  }

  return next(modifiedReq);
};

export function getToken(): string | null {
  const sessionStorageService: SessionStorageService = inject(SessionStorageService);
  const currentUser: User | null = sessionStorageService.getItem<User>('currentUser');
  if (currentUser != null)
    return currentUser.token;
  else return null;
}



